import React, { useState, useEffect, useCallback } from 'react';
import { fetchWatchers, seguirChamado, deixarDeSeguir } from '../../../api/colaboracao';
import './WatchersCard.css';

// Card de seguidores (watchers) + dica de @menções (Fase 8).
function WatchersCard({ satNum }) {
  const [dados, setDados] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(async () => {
    if (!satNum) return;
    const r = await fetchWatchers(satNum);
    setDados(r);
  }, [satNum]);

  useEffect(() => { carregar(); }, [carregar]);

  if (!satNum || satNum <= 0) return null;

  const alternar = async () => {
    setSalvando(true);
    try {
      if (dados && dados.seguindo) await deixarDeSeguir(satNum);
      else await seguirChamado(satNum);
      await carregar();
    } catch (_) {} finally { setSalvando(false); }
  };

  const seguindo = dados && dados.seguindo;
  const total = dados ? dados.total : 0;

  return (
    <div className="watchers-card">
      <div className="watchers-card-top">
        <span className="watchers-card-titulo"><i className="fas fa-eye me-1" />Seguidores{total ? ` (${total})` : ''}</span>
        <button type="button" className={`watchers-btn ${seguindo ? 'seguindo' : ''}`} onClick={alternar} disabled={salvando}>
          <i className={`fas ${seguindo ? 'fa-bell-slash' : 'fa-bell'} me-1`} />
          {seguindo ? 'Seguindo' : 'Seguir'}
        </button>
      </div>
      {dados && dados.watchers && dados.watchers.length > 0 && (
        <div className="watchers-lista" title={dados.watchers.map((w) => w.nome).filter(Boolean).join(', ')}>
          {dados.watchers.slice(0, 5).map((w) => w.nome).filter(Boolean).join(', ')}
          {dados.watchers.length > 5 ? ` +${dados.watchers.length - 5}` : ''}
        </div>
      )}
      <div className="watchers-dica">Dica: use <strong>@login</strong> num comentário para notificar um colega.</div>
    </div>
  );
}

export default WatchersCard;
